import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref, watch } from "vue";
import { Meetings, Userspaces } from "@busy-human/opt-library";
import { useRouter } from "vue-router";
import { DataInstance } from "@busy-human/gearbox";
import CloseButton from "../buttons/close.vue";
import DetailsHeader from "./meeting-details-header.vue";
import TextField from '../text-area.vue';
import StarRating from './star-rating.vue';
import Loader from '@/components/loader.vue';

import { httpsCallable } from 'firebase/functions'
import {functions} from '../../util/firebase'

import { checkLoggedIn } from '@/util/auth';
import moment, { Moment } from 'moment';
import { useUserspace } from "@/store/userspace";


type Props = {
    //The main prop is "Selected Meeting passed by either the meeting details popup or the specific route that uses this popup"
    selectedMeeting: DataInstance<Meetings.Model> | null

    //The secondary prop is userId if the route is suppose to be accessible when you're not logged in
    user?: DataInstance<Userspaces.Model>
}
type Emits = {
    (e: "closePopup"): void
    (e: "deepClosePopup"): void
}
enum CheckInStage {
    FEEDBACK = 1,
    SUCCESS = 2
}


export default /*#__PURE__*/_defineComponent({
  __name: 'check-in-popup',
  props: {
    selectedMeeting: null,
    user: null
  },
  emits: ["closePopup", "deepClosePopup"],
  setup(__props: any, { expose, emit }: { emit: ({
    (e: "closePopup"): void
    (e: "deepClosePopup"): void
}), expose: any, slots: any, attrs: any }) {
  expose();

const props = __props as {
    //The main prop is "Selected Meeting passed by either the meeting details popup or the specific route that uses this popup"
    selectedMeeting: DataInstance<Meetings.Model> | null

    //The secondary prop is userId if the route is suppose to be accessible when you're not logged in
    user?: DataInstance<Userspaces.Model>
}





const stage = ref(CheckInStage.FEEDBACK);

const router = useRouter();

const meetingMoment = ref<Moment>()

const user = ref()
const otherUser = ref()

const isPayingUser = ref<boolean>(false)
const pastMeeting = ref<boolean>(true)

const loading = ref(false)
const error = ref()

const reconfirmPayment = ref<boolean>(false)
const rating = ref<number>(4)
const feedback = ref<string>()

watch(() => props.selectedMeeting, async meeting => {
    if(meeting) {
        if(checkLoggedIn()){
            const currentUser = useUserspace().user
            user.value = currentUser
        }else{
            if(props.user){
                user.value = props.user
            }else{
                //Handle the Invalid User somehow
                return
            }
        }

        let meetingStart = new Date(meeting.startTime)

        meetingMoment.value = moment(new Date(meeting.startTime))

        let now = new Date(Date.now()).toISOString()
        if(meetingStart.toISOString() < now)
            pastMeeting.value = true

        if(user.value.$id == meeting.collector){
            otherUser.value = (await Userspaces.Collection.fetchDoc(meeting.payer)).data()
        }else if(user.value.$id == meeting.payer){
            isPayingUser.value = true;
            if(meeting.paymentStatus === 'failed'){
                reconfirmPayment.value = true
            }
            otherUser.value = (await Userspaces.Collection.fetchDoc(meeting.collector)).data()
        }
    }
}, {immediate: true})

const confirmMeeting = async () => {
    loading.value = true
    const confirmMeeting = httpsCallable<{meetingId: string, userFeedback: Meetings.UserFeedback}, number>(functions, 'confirmMeeting');
    let userFeedback: Meetings.UserFeedback = {
        userId: user.value!.$id,
        rating: rating.value,
        feedback: feedback.value,
    }
    try{
        await confirmMeeting({meetingId: props.selectedMeeting!.$id, userFeedback: userFeedback});
        stage.value = CheckInStage.SUCCESS
    }catch(e){
        if(typeof e === 'string')
            error.value = e
        else
            error.value = "Error: Unexpected Error"
    }

    loading.value = false
}

const closePopup = () => emit('closePopup');
const deepClosePopup = () => emit('deepClosePopup');


const __returned__ = { props, emit, CheckInStage, stage, router, meetingMoment, user, otherUser, isPayingUser, pastMeeting, loading, error, reconfirmPayment, rating, feedback, confirmMeeting, closePopup, deepClosePopup, onMounted, ref, watch, Meetings, Userspaces, useRouter, DataInstance, CloseButton, DetailsHeader, TextField, StarRating, Loader, httpsCallable, functions, checkLoggedIn, moment, Moment, useUserspace }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})